import isProd from './isProduction.ts'

export const endpoints = (prod = isProd()) => ({
  authApiUrl: prod ? 'https://www.citationmachine.net/api/auth' : 'https://playground.citationmachine.net/api/auth',
  editorBaseUrl: prod ? 'https://writing.citationmachine.net' : '//writing-playground.citationmachine.net',
})

const owl = ({
  site = 'owl',
  headingText = 'Check for plagiarism & grammar mistakes',
  subheadingText = 'Wipe out writing errors that can affect your grade',
  pasteOnly = true,
  alignText = 'center',
  initRSW = false,
  initFreshToken = true,
} = {}) => {
  const { editorBaseUrl, authApiUrl } = endpoints()

  return {
    headingText,
    subheadingText,
    authApiUrl,
    editorBaseUrl,
    pasteOnly,
    alignText,
    site,
    initFreshToken,
    initRSW,
  }
}

export default owl
